import { render, staticRenderFns } from "./ProjectPersons.vue?vue&type=template&id=3f961ea4&scoped=true&"
import script from "./ProjectPersons.vue?vue&type=script&lang=js&"
export * from "./ProjectPersons.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPersons.vue?vue&type=style&index=0&id=3f961ea4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f961ea4",
  null
  
)

export default component.exports